module.exports = __webpack_public_path__ + "static/stagency-a6b64d86b7feb975d15970a29b13912b.png";